import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faGoogle, faYelp } from '@fortawesome/free-brands-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { Img } from 'react-image';
import styles from '../LeaveReview.module.scss';

export type ReviewLinks = {
    facebook?: string;
    google?: string;
    yelp?: string;
    trustpilot?: string;
};

interface ShareReviewLinksProps {
    links: ReviewLinks;
    className?: string;
}

const ShareReviewLinks: React.FC<ShareReviewLinksProps> = ({ links, className }) => {
    const items = [
        { key: 'facebook' as const, url: links.facebook, label: 'Facebook', icon: faFacebookF, className: styles.fb },
        { key: 'google' as const, url: links.google, label: 'Google', icon: faGoogle, className: styles.google },
        {
            key: 'trustpilot' as const,
            url: links.trustpilot,
            label: 'Trustpilot',
            icon: faStarSolid,
            className: styles.trustpilot
        },
        { key: 'yelp' as const, url: links.yelp, label: 'Yelp', icon: faYelp, className: styles.yelp }
    ];

    return (
        <div className={`${styles.shareContainer} ${className ?? ''}`.trim()}>
            <div className={styles.shareLeft}>
                <div className={styles.shareTitle}>It would mean a lot to our team if you shared your review on</div>
                <div className={styles.shareButtons}>
                    {items
                        .filter(item => !!item.url)
                        .map(item => (
                            <a
                                key={item.key}
                                href={item.url}
                                className={`${styles.shareBtn} ${item.className}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={`Leave a review on ${item.label}`}
                            >
                                <FontAwesomeIcon icon={item.icon} />
                            </a>
                        ))}
                </div>
            </div>
            <div
                className={styles.shareRight}
                aria-hidden="true"
            >
                <Img
                    src="/images/reviews/thankfull.png"
                    className={styles.shareImage}
                />
            </div>
        </div>
    );
};

export default ShareReviewLinks;
